import React, { useState } from "react";

import { Autocomplete, Button, Stack, TextField } from "@mui/material";
import { useTaskDealsSelect } from "store";
import { DealBase } from "store/types";

interface Props {
  currentDealId: number | null;
  onSubmit: (result: { deal: DealBase }) => void;
  onCancel: () => void;
}

export const DealPrompt: React.FC<Props> = ({ currentDealId, onSubmit, onCancel }) => {
  const deals = useTaskDealsSelect();

  const [selected, setSelected] = useState<DealBase | null>(deals.find((d) => d.id === currentDealId) ?? null);

  return (
    <Stack sx={{ padding: "24px", gap: "20px", minWidth: "427px" }}>
      <Autocomplete
        options={deals}
        disableClearable={Boolean(selected)}
        value={selected}
        onChange={(_, value) => setSelected(value)}
        getOptionLabel={(option) => option.title}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        renderInput={(params) => <TextField {...params} label="Deal" />}
        renderOption={(props, option) => (
          <li {...props} key={option.id} style={{ fontSize: "16px" }}>
            {option.title}
          </li>
        )}
        slotProps={{
          listbox: {
            sx: {
              "& .MuiAutocomplete-option": {
                fontSize: "16px",
                "&:hover, &.Mui-focused": { bgcolor: "#edf1f9" },
                "&[aria-selected='true']": { bgcolor: "#edf1f9", "&.Mui-focused": { bgcolor: "#edf1f9" } }
              }
            }
          }
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            "& fieldset": { borderColor: "#7b92a9" }
          }
        }}
      />
      <Stack direction="row" justifyContent="flex-end" gap="8px">
        <Button
          onClick={onCancel}
          sx={{
            borderRadius: "32px",
            border: "1px solid #7b92a9",
            color: "#071f35",
            textTransform: "none",
            padding: "4px 16px",
            fontSize: "16px",
            fontWeight: 400,
            lineHeight: "24px"
          }}
        >
          Cancel
        </Button>
        <Button
          disabled={!selected}
          onClick={() => {
            if (selected) {
              onSubmit({ deal: selected });
            }
          }}
          sx={{
            borderRadius: "32px",
            bgcolor: "#071f35",
            color: "white",
            textTransform: "none",
            padding: "4px 16px",
            fontSize: "16px",
            fontWeight: 400,
            lineHeight: "24px",
            "&:hover": { bgcolor: "#0a2a45" },
            "&:disabled": { bgcolor: "#bac7ce", color: "white" }
          }}
        >
          Add
        </Button>
      </Stack>
    </Stack>
  );
};
